// Copyright (c) StrangeBee 2024

import client from '@Client';
import { useCallback } from 'react';
import { QueryKey, UseQueryResult } from 'react-query';
import { ObjectType, ResponderOutput } from 'thehive-sdk';
import { useGenericQuery } from './genericQueries';

export const ResponderController = {
    list: {
        key: 'listResponders',
        query: client.ResponderController.list,
    },
    launch: {
        query: client.ResponderController.launch,
    },
};

export const useListResponders = (
    objectType: ObjectType,
    objectId: string,
): UseQueryResult<ResponderOutput[], QueryKey> => {
    const fetchCallback = useCallback(
        () => client.ResponderController.listResponders(objectType, objectId),
        [objectType, objectId],
    );

    return useGenericQuery({ fetchCallback, key: [ResponderController.list.key, objectType, objectId], manual: true });
};
